module.exports = __webpack_public_path__ + "static/JAS-Medical-78a1e4b962934d1825ce3fc5f16bb3f0.jpg";